<template>
  <div v-if="loaded" class="myhome-books">
    <NotificationStripeContainer
      v-if="messagesByType.myHomeBooksStripe.length"
      :messages="messagesByType.myHomeBooksStripe"
      :role="user.role"
    />
    <HomeHeaderButtons
      v-if="booksList.length || flatChildrenBooks.length"
      :link-color="user.targetCss.colorMod"
      :role="user.role"
    >
      <template #button-left>
        <ButtonActivateCopy
          v-if="user.student || user.parent || user.teacher"
          :role="user.role"
          :link-color="user.targetCss.colorMod"
        />
        <ButtonSupport v-else :role="user.role" :link-color="user.targetCss.colorMod" :agents-url="agentsUrl" />
      </template>
      <template #button-right>
        <ButtonSupport
          v-if="user.student"
          :role="user.role"
          :link-color="user.targetCss.colorMod"
          :agents-url="agentsUrl"
        /><ButtonSupport
          v-else-if="user.parent"
          :role="user.role"
          :link-color="user.targetCss.colorMod"
          :agents-url="agentsUrl"
        />
        <ButtonEvaluationCopy
          v-else
          :role="user.role"
          :link-color="user.targetCss.colorMod"
          :catalog-link="catalogLink"
          @open-evaluation-modal="showEvaluationModal = true"
        />
      </template>
    </HomeHeaderButtons>
    <div v-if="booksList.length || flatChildrenBooks.length">
      <div v-if="booksList.length" class="myhome-books__list">
        <div class="grid grid--wide">
          <div class="xs-12">
            <h2 class=" myhome-books__list-title dea-heading--medium__l">
              I miei libri ( {{ numBooks + flatChildrenBooks.length }} )
            </h2>
          </div>
        </div>
        <ActivatedBooksList
          :async-conf="$root.asyncConf"
          columns-class="bookslist__column bookslist__column--mybooks"
          :search="true"
          :items="booksList"
          :list-columns="12"
          :link-color="user.targetCss.colorMod"
          :link-minsite="true"
          :grid-wide="true"
          :extra-info-on-card="true"
          :books="books"
          :show-bookmark="true"
          :show-catalog-link="true"
          :show-volumes-label="!user.student"
          :student="user.student"
          @save-bookmark="addBookmark"
          @delete-bookmark="removeBookmark"
          @update-books-list="$emit('update-books-list')"
        />
      </div>
      <HomeFamilyBooks
        v-if="flatChildrenBooks.length"
        :user="user"
        :aed="[]"
        :books="booksList"
        :children-books="childrenBooksList"
        :children-aed="{}"
        :loaded="loaded"
      />
    </div>
    <EmptyFamilyStudentBookPage
      v-else-if="user.student || user.parent"
      :link-color="user.targetCss.colorMod"
      :role="user.role"
      :user="user"
      :student="user.student"
      :parent="user.parent"
      @open-activation-modal="showActivationModal = true"
      @open-evaluation-modal="showEvaluationModal = true"
    />
    <EmptyBookPage
      v-else
      :link-color="user.targetCss.colorMod"
      :role="user.role"
      :user="user"
      :student="user.student"
      :parent="user.parent"
      @open-activation-modal="showActivationModal = true"
      @open-evaluation-modal="showEvaluationModal = true"
    />
    <BookEvaluationModal
      v-if="showEvaluationModal"
      :config="$root.config.evaluationSearch"
      :link-color="user.targetCss.colorMod"
      :personal-area-logo-list="personalAreaLogoList"
      :user="user"
      :catalog-link="catalogLink"
      @close-modal="showEvaluationModal = false"
    >
      <EvaluationModalContent />
    </BookEvaluationModal>
    <BookEvaluationModal
      v-if="showActivationModal"
      :config="$root.config.activationSearch"
      :link-color="user.targetCss.colorMod"
      :personal-area-logo-list="personalAreaLogoList"
      :user="user"
      :catalog-link="catalogLink"
      @close-modal="showActivationModal = false"
    >
      <ActivationModalContent />
    </BookEvaluationModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NotificationStripeContainer from "@/components/elements/NotificationStripeContainer";
import myHomeBooks from "~/mixins/myHomeBooks";
import ActivatedBooksList from "~/components/books/components/ActivatedBooksList";
import HomeFamilyBooks from "~/components/books/components/HomeFamilyBooks";
import HomeHeaderButtons from "~/components/books/components/HomeHeaderButtons";
import ActivationModalContent from "~/components/books/components/ActivationModalContent";
import BookEvaluationModal from "~/components/books/components/BookEvaluationModal";
import EvaluationModalContent from "~/components/books/components/EvaluationModalContent";
import EmptyBookPage from "~/components/books/components/EmptyBookPage";
import EmptyFamilyStudentBookPage from "~/components/books/components/EmptyFamilyStudentBookPage";
import ButtonActivateCopy from "~/components/books/components/ButtonActivateCopy";
import ButtonSupport from "~/components/books/components/ButtonSupport";
import ButtonEvaluationCopy from "~/components/books/components/ButtonEvaluationCopy";
import BookmarkActions from "~/components/bookmarks/mixins/BookmarkActions";
import UserLinks from "~/components/books/mixins/UserLinks";

export default {
  name: "MyHomeBooks",
  components: {
    ActivatedBooksList,
    HomeFamilyBooks,
    ActivationModalContent,
    BookEvaluationModal,
    HomeHeaderButtons,
    EvaluationModalContent,
    EmptyBookPage,
    EmptyFamilyStudentBookPage,
    ButtonEvaluationCopy,
    ButtonSupport,
    ButtonActivateCopy,
    NotificationStripeContainer,
  },
  mixins: [BookmarkActions, myHomeBooks, UserLinks],
  props: {
    books: {
      type: Array,
      required: true,
    },
    childrenBooks: {
      type: Object,
      default: () => {},
    },
    loaded: {
      type: Boolean,
      default: false,
    },
    personalAreaLogoList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showEvaluationModal: false,
      showActivationModal: false,
    };
  },
  computed: {
    ...mapGetters(["messagesByType"]),
    numBooks() {
      if (this.user.student) return this.books.map(book => book.ebooks.length).reduce((acc, curr) => acc + curr, 0);
      return this.books.length;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-books {
  &__list {
    margin-top: $space-base;
    width: 100%;
  }

  &__list-title {
    margin-bottom: 0;
  }

  &__title {
    @include media("<=s") {
      margin-right: $space-base;
    }
    margin-left: $space-large;
  }

  &__claim-icon {
    font-size: $dea-size-large;
  }

  &__claim {
    @include media("<=xs") {
      margin-left: $space-x-small;
    }
    margin-left: $space-base;
    max-width: 200px;
  }

  &__cta {
    @include media("<=s") {
      margin-left: $space-x-small;
    }

    margin-left: $space-base;

    .dea-button.dea-button--medium {
      @include media("<=xs") {
        padding: $space-x-small;
      }

      .dea-button__label {
        white-space: nowrap;
      }
    }
  }
}
</style>
